<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';

    import unescape from 'lodash/unescape';

    import { NORMALIZE_CSS } from '../constants';

    export let provider = '';
    export let head = '';
    export let body = '';

    let iframeContainer: HTMLIFrameElement;
    let rsObserver: ResizeObserver;

    $: if (iframeContainer && !rsObserver) {
        requestAnimationFrame(() => {
            const { contentWindow: window } = iframeContainer;

            if (!window || typeof window === 'undefined') {
                return;
            }

            const headElem = window.document.getElementsByTagName('head')[0];
            const bodyElem = window.document.getElementsByTagName('body')[0];

            let rawHeadCode = unescape(head);
            let rawBodyCode = unescape(body);

            if (provider !== 'provenexpert') {
                bodyElem.style.display = 'flex';
                bodyElem.style.justifyContent = 'center';
                bodyElem.style.alignItems = 'flex-start';
            }

            const headNode = window.document
                .createRange()
                .createContextualFragment(
                    `${NORMALIZE_CSS}<style>body > a {display:inline-block;}body > .trustpilot-widget{width:100%;}</style>${rawHeadCode}`,
                );

            rsObserver = new ResizeObserver(() => {
                let height = window.document.body.scrollHeight;

                if (provider === 'provenexpert') {
                    height = height + 22; // prevents scrollbar in embed
                }

                iframeContainer.style.height = `${height}px`;
            });

            headElem.innerHTML = '';
            bodyElem.innerHTML = '';

            headElem.appendChild(headNode);

            if (provider === 'google-maps') {
                const extractIframeSrc = (iframeString: string) => {
                    const urlPattern = new RegExp('<iframe src="?(https[^"]+)"?');
                    const match = iframeString.match(urlPattern);
                    return match ? match[1] : null;
                };
                const iframeSrc = extractIframeSrc(rawBodyCode);

                if (!iframeSrc) {
                    console.warn(`Google Maps Embed Error`, {
                        data: {
                            error: JSON.stringify(body),
                        },
                    });
                    return;
                }

                iframeContainer.width = '100%';
                iframeContainer.style.border = '0';
                iframeContainer.style.aspectRatio = '4/3';
                iframeContainer.loading = 'lazy';
                iframeContainer.referrerPolicy = 'no-referrer-when-downgrade';
                iframeContainer.src = iframeSrc;
            } else {
                const bodyNode = window.document
                    .createRange()
                    .createContextualFragment(rawBodyCode);
                bodyElem.appendChild(bodyNode);
            }

            const contentElem =
                Array.from(window.document.body.children).find(
                    (el) => !['STYLE', 'SCRIPT', 'LINK', 'META'].includes(el.tagName),
                ) ?? window.document.body.firstElementChild;

            if (contentElem) {
                rsObserver.observe(contentElem);
            }
        });
    }

    const embedBorderRadiusClass = getBorderRadius('embed');
</script>

<div class="fun-flex fun-justify-center">
    <iframe
        bind:this={iframeContainer}
        class={cn('fun-w-full fun-transition-all max-sm:fun-rounded-none', {
            [embedBorderRadiusClass]: provider !== 'provenexpert',
        })}
        title={`${provider}-embed`}
    />
</div>
